/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/forbid-prop-types */
import React, { Component } from 'react';
import {
  FormGroup,
  TextArea,
  Button,
  DataTable,
  TableContainer,
  TableToolbar,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableHeader,
  TableCell,
  TableToolbarContent,
  Tile,
} from 'carbon-components-react';
import Delete16 from '@carbon/icons-react/lib/delete/16';
import Edit16 from '@carbon/icons-react/lib/edit/16';
import Close16 from '@carbon/icons-react/lib/close/16';
import Add16 from '@carbon/icons-react/lib/add/16';
import Save16 from '@carbon/icons-react/lib/save/16';
import SimpleReactValidator from 'simple-react-validator';
import PropTypes from 'prop-types';
import { v4 as uuid } from 'uuid';
import moment from 'moment';
import { NoRecordsPlaceholder } from '../../../../helpers/jsonschemaform/DataTableExtention';

export default class DrillPersonnel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      drillReport: this.props.drillReport || {},
      modalPersonDetailVisible: false,
      selectedPerson: {
        id: null,
        fullName: '',
      },
    };
    this.handlePersonDetailVisibility = this.handlePersonDetailVisibility.bind(this);
    this.handleDeletePersonModal = this.handleDeletePersonModal.bind(this);
    this.onPersonChanged = this.onPersonChanged.bind(this);
    this.onSubmitPerson = this.onSubmitPerson.bind(this);
    this.onPersonDelete = this.onPersonDelete.bind(this);
    this.savePersonnel = this.savePersonnel.bind(this);

    this.validator = new SimpleReactValidator({
      validators: {
        emails: {
          // name the rule
          message: 'The :attribute must be a valid email address list semicolon separated',
          rule: (val, params, validator) =>
            validator.helpers.testRegex(
              val,
              // eslint-disable-next-line no-useless-escape
              /^(([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)(\s*;\s*|\s*$))+$/i
            ) && params.indexOf(val) === -1,
          required: true, // optional
        },
        time: {
          message: ':attribute must be a valid time',
          rule: (val, params, validator) =>
            validator.helpers.testRegex(val, /^(0[0-9]|1[0-9]|2[0-3]|[0-9]):[0-5][0-9]+$/) &&
            params.indexOf(val) === -1,
          required: true, // optional
        },
        datePicker: {
          message: 'The :attribute must be a valid date with mm/dd/yyyy format',
          rule: (val, params) => moment(val).isValid() && params.indexOf(val) === -1,
          required: true, // optional
        },
      },
    });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.drillReport !== this.props.drillReport) {
      this.setState({ drillReport: nextProps.drillReport });
    }
  }

  onPersonChanged(event) {
    event.preventDefault();
    const { value } = event.currentTarget;
    this.setState((prevState) => {
      const selectedPerson = { ...prevState.selectedPerson };
      selectedPerson.fullName = value;
      return { selectedPerson };
    });
  }

  onSubmitPerson(event) {
    event.preventDefault();
    if (this.validator.fieldValid('fullName')) {
      this.setState((prevState) => {
        const drillReport = { ...prevState.drillReport };
        const selectedPerson = { ...prevState.selectedPerson };
        if (!selectedPerson.id) {
          selectedPerson.id = uuid();
          selectedPerson.idDrillReport = prevState.drillReport.id;
          // drillReport.people = prevState.drillReport.people.concat(
          //   selectedPerson
          // );
          const notact = [selectedPerson];
          drillReport.people = notact.concat(prevState.drillReport.people);
          this.handlePersonDetailVisibility(null);
        } else {
          drillReport.people = prevState.drillReport.people
            .filter((item) => selectedPerson.id !== item.id)
            .concat(selectedPerson);
          this.handlePersonDetailVisibility(null);
        }
        return { drillReport };
      });
    } else {
      this.validator.showMessageFor('fullName');
      this.forceUpdate();
    }
  }

  onPersonDelete() {
    this.setState((prevState) => {
      const drillReport = { ...prevState.drillReport };
      const selectedPerson = { ...prevState.selectedPerson };
      drillReport.people = prevState.drillReport.people.filter(
        (item) => selectedPerson.id !== item.id
      );
      return { drillReport };
    });
    this.handleDeletePersonModal(null);
  }

  savePersonnel() {
    if (this.validator.fieldValid('people')) {
      this.props.onSave(this.state.drillReport);
    } else {
      this.validator.showMessageFor('people');
      this.forceUpdate();
    }
  }

  handlePersonDetailVisibility(id) {
    const person = this.state.drillReport.people.find((i) => i.id === id);
    this.setState((oldState) => ({
      modalPersonDetailVisible: !oldState.modalPersonDetailVisible,
      selectedPerson: person || {},
    }));
  }

  handleDeletePersonModal(id) {
    const person = this.state.drillReport.people.find((i) => i.id === id);
    this.setState((oldState) => ({
      modalPersonDeleteVisible: !oldState.modalPersonDeleteVisible,
      selectedPerson: person || {},
    }));
  }

  renderDeletePeopleModal = () =>
    this.state.modalPersonDeleteVisible && (
      <div className="bx--modal bx--modal-tall is-visible">
        <div className="bx--modal-container">
          <div className="bx--modal-header">
            <h3 className="bx--modal-header__heading">Delete Person</h3>
            <Button
              className="bx--modal-close"
              renderIcon={Close16}
              onClick={this.handleDeletePersonModal}
              iconDescription=""
            />
          </div>

          <div className="bx--modal-content">
            <div className="bx--row bx--modal-content-detail">
              <div className="bx--col-lg-12 bx--col-md-12">
                <h5 className="align-center">Press confirm to remove selected person</h5>
              </div>
            </div>
          </div>
          <div className="bx--modal-footer">
            <Button
              className="button--max-width"
              kind="secondary"
              onClick={this.handleDeletePersonModal}
            >
              Cancel
            </Button>
            <Button className="button--max-width" kind="primary" onClick={this.onPersonDelete}>
              Confirm
            </Button>
          </div>
        </div>
      </div>
    );

  renderNewPersonModal = () => {
    const validationsModal = {
      fullName: this.validator.message('fullName', this.state.selectedPerson.fullName, 'required'),
    };
    return (
      this.state.modalPersonDetailVisible && (
        <div className="bx--modal bx--modal-tall is-visible">
          <div className="bx--modal-container">
            <div className="bx--modal-header">
              <h3 className="bx--modal-header__heading">Add New Person</h3>
              <Button
                className="bx--modal-close"
                renderIcon={Close16}
                onClick={this.handlePersonDetailVisibility}
                iconDescription=""
              />
            </div>

            <div className="bx--modal-content information">
              <div className="bx--row">
                <div className="bx--col-lg-12 bx--col-md-12 paddingTopRow">
                  <FormGroup legendText="Full Name">
                    <TextArea
                      maxLength={5000}
                      labelText=""
                      id="inputPerson"
                      cols={250}
                      disabled={this.props.editingDisabled}
                      invalid={validationsModal.fullName != null}
                      invalidText={validationsModal.fullName}
                      light
                      placeholder="Input Full Name"
                      rows={4}
                      value={this.state.selectedPerson.fullName || ''}
                      onChange={this.onPersonChanged}
                    />
                  </FormGroup>
                </div>
              </div>
            </div>
            <div className="bx--modal-footer">
              <Button
                className="button--max-width"
                kind="secondary"
                onClick={this.handlePersonDetailVisibility}
              >
                Cancel
              </Button>
              <Button className="button--max-width" kind="primary" onClick={this.onSubmitPerson}>
                Confirm
              </Button>
            </div>
          </div>
        </div>
      )
    );
  };

  render() {
    const validations = {
      people: this.validator.message(
        'people',
        this.state.drillReport.people?.length > 0 ? this.state.drillReport.people[0] : false,
        'required'
      ),
    };

    const headers = [
      {
        key: 'fullName',
        header: 'Full Name',
      },
    ];
    return (
      <div>
        <Tile light>
          <DataTable
            useZebraStyles
            rows={this.state.drillReport.people || []}
            headers={headers}
            render={({ rows, getHeaderProps }) => (
              <TableContainer>
                <TableToolbar>
                  <TableToolbarContent className="table-toolbar-custom-content">
                    <div className="bx--col-lg-8 bx--col-md-10 table-toolbar-custon-content-info-start ">
                      <h6>List Of People With Active Function</h6>
                    </div>
                    {!this.props.editingDisabled ? (
                      <div className="bx--col-lg-4 bx--col-md-2 table-toolbar-custon-content-info-end ">
                        <Button
                          onClick={this.handlePersonDetailVisibility}
                          kind="primary"
                          renderIcon={Add16}
                          disabled={this.props.editingDisabled}
                          iconDescription=""
                        >
                          Add New Person
                        </Button>
                      </div>
                    ) : (
                      ''
                    )}
                  </TableToolbarContent>
                </TableToolbar>
                {this.renderDeletePeopleModal()}
                {this.renderNewPersonModal()}
                <Table>
                  <TableHead>
                    <TableRow>
                      {headers.map((header) => (
                        <TableHeader {...getHeaderProps({ header })}>{header.header}</TableHeader>
                      ))}
                      <TableHeader className="align-center">Actions</TableHeader>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {!rows || rows.length < 1 ? (
                      <NoRecordsPlaceholder labelText="No Records" colSpan={headers.length + 1} />
                    ) : (
                      rows.map((row) => (
                        <TableRow key={`row_${row.id}`}>
                          {row.cells.map((cell) => (
                            <TableCell key={cell.id}>
                              {cell.info.header.includes('date')
                                ? moment(cell.value).format('DD/MM/YYYY')
                                : cell.info.header.includes('workSite')
                                ? cell.value?.name || 'N/A'
                                : cell.value}
                            </TableCell>
                          ))}
                          <TableCell key="action" className="tableActions align-center">
                            {!this.props.editingDisabled ? (
                              <div>
                                <Button
                                  onClick={() => this.handlePersonDetailVisibility(row.id)}
                                  size="small"
                                  renderIcon={Edit16}
                                  iconDescription="Edit"
                                  kind="ghost"
                                  disabled={this.props.editingDisabled}
                                />
                                <Button
                                  onClick={() => this.handleDeletePersonModal(row.id)}
                                  size="small"
                                  renderIcon={Delete16}
                                  iconDescription="Delete"
                                  kind="ghost"
                                  disabled={this.props.editingDisabled}
                                />
                              </div>
                            ) : (
                              ''
                            )}
                          </TableCell>
                        </TableRow>
                      ))
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          />
          {validations.people}
        </Tile>
        {!this.props.editingDisabled ? (
          <div className="bx--row table-toolbar-custon-content-info-end ">
            <Button
              size="default"
              renderIcon={Save16}
              kind="secondary"
              onClick={this.savePersonnel}
              disabled={this.props.editingDisabled}
              iconDescription=""
            >
              Save
            </Button>
          </div>
        ) : (
          ''
        )}
      </div>
    );
  }
}

DrillPersonnel.propTypes = {
  id: PropTypes.string.isRequired,
  PersonnelData: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
  onSave: PropTypes.func.isRequired,
};
DrillPersonnel.defaultProps = {
  disabled: true,
};
